<template>
<div>
 <ModalPeriodoConsumoOxigeno :show="showModal"  :seriesFaenas="seriesFaenas"  @close="closeModal" > </ModalPeriodoConsumoOxigeno>
<span class="font-semibold "> {{ $t('consumo_oxigeno') }}</span>
 
    
                <table   class="divide-gray-300  border-spacing-0 m-0">
                <tbody class="divide-y divide-gray-200 bg-white ">

                        <tr>
                            <td class="whitespace-nowrap py-0    text-xs   text-gray-900 ">{{ $t('hoy') }}  {{ diahoy}} :</td>
                            <td class="whitespace-nowrap px-3  pl-2 py-2 text-xs text-gray-700"> {{  this.valores[0] }}  ton</td>

                        </tr>

                        <tr>
                            <td class="whitespace-nowrap py-0   text-xs   text-gray-900"> {{ $t('mesencurso') }}:</td>
                            <td class="whitespace-nowrap px-3 pl-2 py-2 text-xs text-gray-700">{{  this.valores[1] }}  ton</td>

                        </tr>
                        <tr>
                            <td class="whitespace-nowrap py-0  text-xs   text-gray-900 "> {{ $t('periodocontar') }} {{ $t('from') }} {{ '15' }} {{  $t('Marzo')}} {{ '2025' }}:</td>
                            <td class="whitespace-nowrap px-3  pl-2 py-2 text-xs text-gray-700"> {{  this.valores[2] }}  ton 
                        
                                
                            </td>
                        </tr>

                   
                
                    </tbody>
                </table>
    </div>
 
</template>
<script>
  
    export default {
        data(){
            return{
                visible:false,
                showModal: false,
                valores:Array,
                diahoy:'',
                mescurso:'',
                nomMes: ['', 'Jan', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            }
        },
        components:{
          
        },
        props:["idFaena","consumo_oxigeno","seriesFaenas"],
        mounted(){
           

     
          this.valores=["0.7", "9.6","82.3"]

            let objFechaHora =this.$store.getters.fechaHoraActual();
            let año = objFechaHora.getFullYear;
            let mes =  parseInt(objFechaHora.getMonth)  ;
            let dia = parseInt(objFechaHora.getDate)  ;

            // Formatear la fecha en el formato deseado (por ejemplo, YYYY-MM-DD)
            this.mescurso=this.nomMes[Number(mes)]
            this.diahoy =   ((dia < 10 ? '0' : '') + dia )+ ' ' + this.nomMes[Number(mes)]  + ' ' + año;

        },
        methods:{
            modalPeriodos(){
                console.log('modal periodos')
                this.showModal=true;
            },
            closeModal() {
            this.showModal = false
            console.log('cerrar modal 2');
            }
        }
    } 
</script>